import setupAxios from './Base'
const prefix = '/_api_'

const axios = setupAxios()

export default class Invites {
  constructor(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token.token}`
  }

  getSaveTheDateInfo(wed) {
    return axios
      .get(`${prefix}/getSavethedateInfo?wed=${wed}`)
      .then((response) => response.data)
      .catch(() => false)
  }
}
